import React from 'react';
// This component is needed in order to apply gradients to SVG icons
export const SvgGradients = ()=>/*#__PURE__*/ React.createElement("svg", {
        height: "0",
        width: "0",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "brand",
        x1: "0%",
        x2: "100%",
        y1: "28%",
        y2: "72%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "24.14%",
        style: {
            stopColor: 'rgb(52,75,241)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "105.44%",
        style: {
            stopColor: 'rgb(45,197,250)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "cyber",
        x1: "100%",
        x2: "0%",
        y1: "65%",
        y2: "35%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'rgb(249,228,80)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.67%",
        style: {
            stopColor: 'rgb(43,207,197)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "data",
        x1: "100%",
        x2: "0%",
        y1: "62%",
        y2: "38%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'rgb(250,242,52)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "96.5%",
        style: {
            stopColor: 'rgb(236,57,138)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "interactive",
        x1: "0%",
        x2: "100%",
        y1: "50%",
        y2: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "-7.48%",
        style: {
            stopColor: 'rgb(56,0,235)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "113.27%",
        style: {
            stopColor: 'rgb(154,22,240)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "ux",
        x1: "0%",
        x2: "100%",
        y1: "38%",
        y2: "62%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "27.18%",
        style: {
            stopColor: 'rgb(236,57,138)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        style: {
            stopColor: 'rgb(154,22,240)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "web",
        x1: "0%",
        x2: "100%",
        y1: "35%",
        y2: "65%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "17.93%",
        style: {
            stopColor: 'rgb(154,22,240)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "92.3%",
        style: {
            stopColor: 'rgb(45,197,250)',
            stopOpacity: 1
        }
    }))));

//# sourceMappingURL=SvgGradients.js.map